import { ReactNode, useState } from 'react';
import Checkbox from '@alltrails/denali/components/Checkbox';
import logCheckoutTermsandConditionsChecked from '@alltrails/amplitude/events/logCheckoutTermsandConditionsChecked';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './ComplianceCheckbox.module.scss';

type ComplianceCheckboxProps = {
  finePrint: ReactNode;
  onChange: (checked: boolean) => void;
  checked?: boolean;
  error?: boolean;
};

const ComplianceCheckbox = ({ finePrint, onChange, checked, error }: ComplianceCheckboxProps) => {
  const [isChecked, setIsChecked] = useState(checked || false);

  const handleChange = (checked: boolean) => {
    setIsChecked(checked);
    onChange(checked);

    if (checked) {
      logCheckoutTermsandConditionsChecked();
    }
  };

  return (
    <Checkbox
      className={classNames(styles.checkboxContainer, { [styles.error]: error })}
      id="compliance-checkbox"
      testId="compliance-checkbox"
      selected={isChecked}
      onChange={handleChange}
      labelElement={
        <div key="label" className={styles.finePrintContainer}>
          <span className={styles.required}>
            <FormattedMessage defaultMessage="Required:" />{' '}
          </span>
          {finePrint}
        </div>
      }
      hasComplianceExperimentError={error}
    />
  );
};

export default ComplianceCheckbox;
